export const DEFAULT_REPEAT_CALL_SETTINGS = {
  maxDistance: 7 * 24 * 60 * 60,
  minDistance: 15 * 60,
}
